module.exports = __webpack_public_path__ + "static/media/06_twitter_image.ec76a823.jpg";